import { Component, Inject, OnInit } from "@angular/core";
// import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { SharedService } from "@shared/services/shared.service";
import { ICorrespondenceView } from "app/models/mainMenu/mainMenu";
import { IEnclosedAreaFileView } from "app/models/reports/reports";
import { ComplaintService } from "app/services/complaint/complaint.service";

@Component({
  selector: 'addFileCorrespondence',
  styleUrls: ['./addFileCorrespondence.component.scss'],
  templateUrl: './addFileCorrespondence.component.html'
})

export class AddFileCorrespondenceComponent implements OnInit {

  file: File;
  saved: boolean = false;
  fileName: string = '';
  correspondence: ICorrespondenceView = {} as ICorrespondenceView;

  constructor(
    private sharedService: SharedService,
    private complaintService: ComplaintService,
    // private datePipe: DatePipe,
    private dialogRef: MatDialogRef<AddFileCorrespondenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.correspondence != null && this.data.correspondence != undefined) {
      this.correspondence = this.data.correspondence;
    }
    }

  ngOnInit(): void {
    this.saved = false;
    // this.ids = this.citation.id > 0 ? true : false;
  }

  addFile() {
    if (this.file != null) {
      let formData = new FormData();
      formData.append('ComplaintId', this.correspondence.complaintId.toString());
      formData.append('BusinessId', this.correspondence.businessId.toString());
      formData.append('Name', this.correspondence.title);
      formData.append('CorrespondenceId', this.correspondence.id.toString());
      formData.append('Description', '');
      formData.append('Type', this.correspondence.typeId.toString());
      formData.append('fileToUpload', this.file, this.file.name);

      this.complaintService.addFileCorrespondence(formData).subscribe(
        (result) => {
          this.sharedService.toastr.success("File Saved Successfully");
          this.saved = true;
          this.return();
        },
        error => {
          this.sharedService.toastr.error("Could not save file: " + error.message);
        }
      );
    }
    else {
      this.sharedService.toastr.error("No file selected");
    }
  }

  uploadFile(event): void {
    this.file = event.target.files[0];
    this.fileName = this.file.name;
  }

  return(): void {
    let returnData = this.saved ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }

}